<template>
    <div>
        <OrderList v-model="stepOutcomes" listStyle="height:'auto'" :data-key="stepOutcomes.id">
            <template #header>
                <div class="flex justify-content-between">
                    <span>List of Pass Criteria</span>
                    <span>
                        <Button icon="pi pi-question-circle" class="p-button-rounded mr-2 mb-2 p-button-secondary" @click="helpVisible = true" v-tooltip="'Help'" />
                        <Button icon="pi pi-plus" class="p-button-rounded mr-2 mb-2" v-tooltip="'Add a new criteria'" @click="openOutcomeForm('add')" />
                    </span>
                </div>
            </template>
            <template #item="slotProps">
                <div class="flex justify-content-between">
                    <span class="font-bold">Criteria {{ slotProps.item.id }}</span>
                    <div class="flex justify-content-between">
                        <Button icon="pi pi-eye" class="p-button-sm p-button-rounded mr-1 mb-2" v-tooltip="'View Outcome Criteria'" @click="viewLinkDetails(slotProps.item)" />
                        <Button icon="pi pi-pencil" class="p-button-sm p-button-rounded p-button-secondary mr-1 mb-2" v-tooltip="'Edit Outcome Criteria'" @click="openOutcomeForm('edit', slotProps.item)" />
                        <Button icon="pi pi-trash" class="p-button-sm p-button-rounded p-button-danger mr-1 mb-2" v-tooltip="'Delete Outcome Criteria'" @click="confirmDelete(slotProps.item)" />
                    </div>
                </div>
            </template>
        </OrderList>
        <!-- Outcome Form Dialog -->
        <outcome-form v-if="outcomeFormDialog" :mode="mode" @hide-dialog="outcomeFormDialog = false" />

        <Dialog v-model:visible="helpVisible" :style="{ width: '450px' }" header="Add Pass Criteria for your step" :modal="true" @hide="helpVisible = false">
            <p>
                A step could have more than one requirements: at least one must pass to mark the step as <Tag severity="success" value="PASS"></Tag>.
            </p>
            <p>
                If one or more steps are marked as <b>FAIL</b>, the whole assessment will be marked as <Tag severity="danger" value="FAIL"></Tag>.
            </p>
            <p>
                If all steps are marked as <b>PASS</b> the assessment will be marked as <Tag severity="success" value="PASS"></Tag>.
            </p>
            <template #footer>
                <Button label="Close" @click="helpVisible = false" />
            </template>
        </Dialog>
    </div>
</template>

<script setup>
import OutcomeForm from './OutcomeForm.vue';
import { ref, computed, inject } from 'vue';
import { useToast } from 'primevue/usetoast';
import { useConfirm } from 'primevue/useconfirm';
import { useStepOutcomeStore } from '../store';

const toast = useToast();
const confirm = useConfirm();

const store = useStepOutcomeStore();
const stepStore = inject('stepStore');

const outcomeFormDialog = ref(false);
const mode = ref(null);
const helpVisible = ref(false);

// returns the list of existing pass/fail criteria
const stepOutcomes = computed(() => {
    return store.outcomes;
});

const openOutcomeForm = (optMode, outcomeData = null) => {
    mode.value = optMode;
    outcomeFormDialog.value = true;
    if (mode.value === 'edit') {
        store.editOutcome(outcomeData);
    }
};

const confirmDelete = (outcomeCriteria) => {
    confirm.require({
        header: 'Delete Confirmation',
        message: 'Are you sure you want to delete the outcome criteria ?',
        icon: 'pi pi-info-circle',
        accept: async () => {
            // requires step id as well as outcome criteria id
            await store.deleteOutcome(stepStore.activeStep?.id, outcomeCriteria?.id);
        },
        reject: () => {
            toast.add({ severity: 'error', summary: 'Rejected', detail: 'Cancelled', life: 5000 });
        },
    });
};
</script>
